import { combineReducers } from 'redux';
import { dadataBank } from '../../modules/dadataBank/reducers';
import { customers } from './customers';
import { customerCard } from './customerCard';
import { fieldsConfig } from './fieldsConfig';
import { filters } from './filters';

export const Customers = combineReducers({
  dadataBank,
  customers,
  customerCard,
  fieldsConfig,
  filters,
});
